import { CaretRightOutlined, CaretUpOutlined, EyeOutlined, SettingOutlined } from "@ant-design/icons";
import { Space } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { ColumnKey } from "../../Customers/Tabs/CarListCardClone";
import { ICustomer, ListField } from "../../../api/Customer_V2/customerApi_V2";
import { Column, TableRow } from "./TableCustom/hook/types";
import CustomerFeilds from "../../CustomersV2/Drawer/CustomerFeilds";
import { DataTable } from "./TableCustom/DataTable";
import ModalFilterTable from "./TableCustom/Modal/ModalFilterTable";
import { set } from "lodash";
import { FlattenedField } from "../../CustomersV2/indexV2";
// ------------------------- Demo data (ICustomer) -------------------------
const dataCarTest: any[] = [
    // ===== GROUP 1 =====
    {
        id: 1,
        code: "CAR001",
        name: "Toyota Hiace",
        groupPermissionId: 1,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe tải bus" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Toyota" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Hiace" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2020" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "850000000" },
        ],
        permissionMenu: { groupPermissionId: 1, view: true, edit: false, delete: false },
    },
    {
        id: 999,
        code: "CAR001B",
        name: "Toyota Granvia",
        groupPermissionId: 1,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe tải bus" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Toyota" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Granvia" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2025" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "900000000" },
        ],
        permissionMenu: { groupPermissionId: 1, view: true, edit: false, delete: false },
    },
    {
        id: 2,
        code: "CAR002",
        name: "Toyota Camry",
        groupPermissionId: 1,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Toyota" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Camry" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2023" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "1500000000" },
        ],
        permissionMenu: { groupPermissionId: 1, view: true, edit: true, delete: false },
    },
    {
        id: 3,
        code: "CAR003",
        name: "Hyundai County",
        groupPermissionId: 1,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe tải bus" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Hyundai" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "County" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2021" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "1100000000" },
        ],
        permissionMenu: { groupPermissionId: 1, view: true, edit: true, delete: false },
    },
    {
        id: 4,
        code: "CAR004",
        name: "Hyundai SantaFe",
        groupPermissionId: 1,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Hyundai" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "SantaFe" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2020" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "780000000" },
        ],
        permissionMenu: { groupPermissionId: 1, view: true, edit: false, delete: false },
    },

    // ===== GROUP 2 =====
    {
        id: 5,
        code: "CAR005",
        name: "Mazda CX-5",
        groupPermissionId: 2,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Mazda" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "CX-5" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2023" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "950000000" },
        ],
        permissionMenu: { groupPermissionId: 2, view: true, edit: true, delete: false },
    },
    {
        id: 6,
        code: "CAR006",
        name: "Mazda CX-8",
        groupPermissionId: 2,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Mazda" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "CX-8" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2022" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "1050000000" },
        ],
        permissionMenu: { groupPermissionId: 2, view: true, edit: true, delete: true },
    },
    {
        id: 7,
        code: "CAR007",
        name: "VinFast Lux A2.0",
        groupPermissionId: 2,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "VinFast" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Lux A2.0" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2021" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "1050000000" },
        ],
        permissionMenu: { groupPermissionId: 2, view: true, edit: true, delete: true },
    },
    {
        id: 8,
        code: "CAR008",
        name: "VinFast VF8",
        groupPermissionId: 2,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "VinFast" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "VF8" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2023" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "1200000000" },
        ],
        permissionMenu: { groupPermissionId: 2, view: true, edit: false, delete: false },
    },

    // ===== GROUP 3 =====
    {
        id: 9,
        code: "CAR009",
        name: "Honda Civic",
        groupPermissionId: 3,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Honda" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Civic" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2022" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "900000000" },
        ],
        permissionMenu: { groupPermissionId: 3, view: true, edit: false, delete: false },
    },
    {
        id: 10,
        code: "CAR010",
        name: "Honda Accord",
        groupPermissionId: 3,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Honda" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Accord" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2023" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "1300000000" },
        ],
        permissionMenu: { groupPermissionId: 3, view: true, edit: true, delete: true },
    },
    {
        id: 11,
        code: "CAR011",
        name: "Toyota Corolla",
        groupPermissionId: 3,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Toyota" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Corolla" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2021" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "820000000" },
        ],
        permissionMenu: { groupPermissionId: 3, view: true, edit: true, delete: true },
    },
    {
        id: 12,
        code: "CAR012",
        name: "Toyota Yaris",
        groupPermissionId: 3,
        fields: [
            { fieldId: 1, fieldLabel: "Dòng xe", fieldCode: "carType", value: "Dòng xe du lịch" },
            { fieldId: 2, fieldLabel: "Thương hiệu", fieldCode: "brand", value: "Toyota" },
            { fieldId: 3, fieldLabel: "Tên xe", fieldCode: "nameCar", value: "Yaris" },
            { fieldId: 4, fieldLabel: "Năm sản xuất", fieldCode: "year", value: "2020" },
            { fieldId: 5, fieldLabel: "Giá xe", fieldCode: "price", value: "670000000" },
        ],
        permissionMenu: { groupPermissionId: 3, view: true, edit: false, delete: false },
    },
];

// ------------------------- Field config (active/inactive) -------------------------
export const dataListFieldsByCustomerRecordActive = [
    {
        id: 1,
        title: "Thông tin cá nhân",
        fields: [
            { id: 20, fieldCode: "carType", fieldLabel: "Dòng xe", inputType: "string", isActive: 1 },
            { id: 1, fieldCode: "brand", fieldLabel: "Thương hiệu", inputType: "string", isActive: 1 },
            { id: 2, fieldCode: "nameCar", fieldLabel: "Tên xe", inputType: "string", isActive: 1 },
            { id: 3, fieldCode: "year", fieldLabel: "Năm sản xuất", inputType: "number", isActive: 1 },
            { id: 4, fieldCode: "price", fieldLabel: "Giá xe", inputType: "number", isActive: 1 },
        ],
    },
];

export const dataListFieldsByCustomerRecordNotActive = [
    { id: 1, title: "Thông tin người liên hệ", fields: [] },
];
const numeric = new Set(["year", "price"]);
// ------------------------- Types for table rows -------------------------
type Role = "Admin" | "User" | "Guest";
type RowKind = "group-city" | "group-role" | "detail";

// Bảng Car: detail là map fields
type AppRowCar = {
    kind: RowKind;
    city?: string; // dùng cho group cấp 1 = carType
    role?: string; // dùng cho group cấp 2 = brand
    count?: number;
    fields?: Record<string, string | number | null | undefined>;
};

// ------------------------- Expand keys helpers -------------------------
const kCity = (carType: string) => `city:${carType}`;
const kRole = (carType: string, brand: string) => `role:${carType}|${brand}`;

// ------------------------- Build rows from dataCarTest -------------------------
function getFieldValue(
    car: ICustomer,
    code: string
): string | number | null | undefined {
    return car.fields.find((f) => f.fieldCode === code)?.value as
        | string
        | number
        | null
        | undefined;
}

function buildViewRowsCar(
    cars: ICustomer[],
    expanded: Set<string>
): TableRow<AppRowCar>[] {
    const out: TableRow<AppRowCar>[] = [];
    let autoId = 1;

    // Group theo carType -> brand
    const byType = new Map<string, ICustomer[]>();
    for (const c of cars) {
        const type = (getFieldValue(c, "carType") as string) || "Khác";
        if (!byType.has(type)) byType.set(type, []);
        byType.get(type)!.push(c);
    }

    // duyệt từng carType
    for (const [carType, carsOfType] of byType.entries()) {
        // push group carType
        out.push({
            id: `grp-city:${carType}`,
            data: { kind: "group-city", city: carType, count: carsOfType.length },
        });

        if (!expanded.has(kCity(carType))) continue;

        // group tiếp theo brand
        const byBrand = new Map<string, ICustomer[]>();
        for (const c of carsOfType) {
            const brand = (getFieldValue(c, "brand") as string) || "Unknown";
            if (!byBrand.has(brand)) byBrand.set(brand, []);
            byBrand.get(brand)!.push(c);
        }

        for (const [brand, brandCars] of byBrand.entries()) {
            out.push({
                id: `grp-role:${carType}:${brand}`,
                data: {
                    kind: "group-role",
                    city: carType,
                    role: brand,
                    count: brandCars.length,
                },
            });

            if (!expanded.has(kRole(carType, brand))) continue;

            for (const car of brandCars) {
                // map fields theo fieldCode
                const fields: Record<string, any> = {};
                car.fields.forEach((f) => {
                    fields[f.fieldCode] = f.value ?? null;
                });

                out.push({
                    id: `detail:${carType}:${brand}:${autoId++}`,
                    data: {
                        kind: "detail",
                        city: carType,
                        role: brand,
                        fields,
                    },
                });
            }
        }
    }

    return out;
}

// ------------------------- Columns (static + dynamic) -------------------------
function makeColumnsCar(
    expanded: Set<string>,
    toggleCity: (carType: string) => void,
    toggleRole: (carType: string, brand: string) => void,
    columnsMapShow: string[]
): Column<AppRowCar>[] {
    // Cột tĩnh: expand + Tên xe/Số lượng
    const staticCols: Column<AppRowCar>[] = [
        {
            id: "action",
            header: "Hành động",
            renderCell: ({ row }) => {
                if (row.kind === "group-city") {
                    const isOpen = expanded.has(kCity(row.city!));
                    return (
                        <button
                            onClick={() => toggleCity(row.city!)}
                            style={{
                                all: "unset",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 8,
                                fontWeight: 600,
                            }}
                            title="Mở/thu"
                        >
                            {!isOpen ? (
                                <CaretRightOutlined style={{ color: "#344054" }} />
                            ) : (
                                <CaretUpOutlined style={{ color: "#40A9FF" }} />
                            )}
                            <span>{row.city}</span>
                        </button>
                    );
                }
                if (row.kind === "group-role") {
                    const isOpen = expanded.has(kRole(row.city!, row.role!));
                    return (
                        <div style={{ paddingLeft: 28 }}>
                            <button
                                onClick={() => toggleRole(row.city!, row.role!)}
                                style={{
                                    all: "unset",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 8,
                                    fontWeight: 600,
                                }}
                                title="Mở/thu"
                            >
                                {!isOpen ? (
                                    <CaretRightOutlined style={{ color: "#344054" }} />
                                ) : (
                                    <CaretUpOutlined style={{ color: "#40A9FF" }} />
                                )}
                                <span>{row.role}</span>
                            </button>
                        </div>
                    );
                }
                return (
                    <Space size="middle" className="w-full">
                        <div className="custom-page-css w-full flex justify-center items-center">
                            <EyeOutlined className="text-sm border-D9D9D9 p-5-px bg-white rounded-2" />
                        </div>
                    </Space>
                );
            },
        },
        {
            id: "nameCar",
            header: "Tên xe",
            sortable: true,
            renderCell: ({ row }) => {
                if (row.kind !== "detail") {
                    return (
                        <span style={{ color: "#096DD9", fontWeight: 500, fontSize: 14 }}>
                            Số lượng: {row.count}
                        </span>
                    );
                }
                return (
                    <span style={{ color: "#344054", fontWeight: 500, fontSize: 14 }}>
                        {row.fields?.["nameCar"] as string}
                    </span>
                );
            },
        },
    ];

    // Cột động: theo cấu hình + columnsMapShow, bỏ nameCar để tránh trùng với cột tĩnh
    const allFields = dataListFieldsByCustomerRecordActive.flatMap((g) => g.fields);
    const activeFields = allFields.filter((f) => columnsMapShow.includes(f.fieldCode));
    const dynamicFields = activeFields.filter((f) => f.fieldCode !== "nameCar");

    const dynamicCols: Column<AppRowCar>[] = dynamicFields.map((f) => ({
        id: f.fieldCode,
        header: f.fieldLabel,
        sortable: true,
        accessor: (row) => {
            if (row.kind !== "detail") return numeric.has(f.fieldCode) ? Number.NEGATIVE_INFINITY : "";
            const v = row.fields?.[f.fieldCode];
            return numeric.has(f.fieldCode) ? Number(v ?? 0) : String(v ?? "");
        },
        renderCell: ({ row }) =>
            row.kind === "detail" ? <span>{row.fields?.[f.fieldCode]}</span> : null,
    }));

    return [...staticCols, ...dynamicCols];
}

// ========================= Component =========================
const TestTableCar: React.FC = () => {
    useEffect(() => {
        gListFieldsActive();
    }, []);

    const [isSettingShow, setSettingShow] = useState(false);
    const [isModalFilter, setModalFilter] = useState(false);

    const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([]);
    const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([]);
    const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);
    const filterColumn = ['nameCar', 'year', 'price'];

    // expanded set
    const [expanded, setExpanded] = React.useState<Set<string>>(new Set());

    const gListFieldsActive = async () => {
        const flattenedFields = dataListFieldsByCustomerRecordActive.flatMap((choice) =>
            choice.fields.map((field) => ({
                ...field,
                parentId: choice.id,
            }))
        );
        setDataFilterActive(flattenedFields);
        gListFieldsNotActive();
    };

    const gListFieldsNotActive = async () => {
        setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive);
    };

    const onSaveDataFields = (
        iSsuccess?: boolean,
        message?: string,
        dataFilterActiveParam?: FlattenedField[],
        dataFilterNoActiveParam?: ListField[]
    ) => {
        if (iSsuccess) {
            // ví dụ khi save xong cấu hình
            setSettingShow(false)
            setDataFilterActive(dataFilterActiveParam ?? [])
            setDataFilterNoActive(dataFilterNoActiveParam ?? [])
        } else {
            // cảnh báo...
        }
    };

    // Toggle expand
    const toggleCarType = React.useCallback((carType: string) => {
        setExpanded((prev) => {
            const next = new Set(prev);
            const key = kCity(carType);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    }, []);

    const toggleBrand = React.useCallback((carType: string, brand: string) => {
        setExpanded((prev) => {
            const next = new Set(prev);
            const key = kRole(carType, brand);
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    }, []);

    // Đồng bộ columnsMapShow từ cấu hình active
    useEffect(() => {
        const codes = dataFilterActive.map((f) => f.fieldCode) as ColumnKey[];
        setColumnsMapShow(codes);
        // console.log(codes)
    }, [dataFilterActive]);

    // Build rows từ dataCarTest
    const viewRowsCar = useMemo(
        () => buildViewRowsCar(dataCarTest, expanded),
        [expanded]
    );

    // Columns (tĩnh + động)
    const columnsCar = useMemo(
        () => makeColumnsCar(expanded, toggleCarType, toggleBrand, columnsMapShow as string[]),
        [expanded, toggleCarType, toggleBrand, columnsMapShow]
    );

    // debug
    useEffect(() => {
        console.log(columnsCar, viewRowsCar);
    }, [columnsCar, viewRowsCar]);

    const openModalFilter = (isOpen: boolean, idCol: string) => {
        setModalFilter(isOpen);
        console.log(idCol);
    }

    return (
        <>
            {isSettingShow ? (
                <CustomerFeilds
                    isSettingShow={isSettingShow}
                    type={1}
                    dataFilterActive={dataFilterActive}
                    dataFilterNoActive={dataFilterNoActive}
                    onSaveDataFields={onSaveDataFields}
                    onClose={() => setSettingShow(false)}
                />
            ) : null}
            <ModalFilterTable isOpen={isModalFilter} closeModal={setModalFilter} />

            <div
                className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs"
                style={{ width: "100%" }}
            >
                <div
                    className="w-6 h-6 d-flex justify-center align-center cursor-pointer border-D9D9D9 rounded-2 color-icon-setting"
                    onClick={() => setSettingShow(true)}
                    title="Cấu hình cột"
                >
                    <SettingOutlined />
                </div>

                <DataTable<AppRowCar>
                    openModalFilter={openModalFilter}
                    columns={columnsCar}
                    filterColumn={filterColumn}
                    rows={viewRowsCar}
                    rowClassName={(row) =>
                        row.data.kind === "group-city" || row.data.kind === "group-role"
                            ? "row-group"
                            : ""
                    }
                />
            </div>
        </>
    );
};

export default TestTableCar;
